import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { App } from './App';
import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import { Authenticator, msalInstance } from 'components/Auth/Authenticator';
// import { SignIn } from 'components/Auth/SignIn';
import { ThemeProvider } from '@landsvirkjun/react.common';
import { Provider } from 'react-redux';
import { store } from 'store';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'utils/QueryClient';
import { Analytics } from 'utils/Analytics';
import { SignIn } from 'routes/signIn';

Analytics();
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <ThemeProvider useLegacyFont={false}>
        <Authenticator />
        <UnauthenticatedTemplate>
          <SignIn />
        </UnauthenticatedTemplate>
        <AuthenticatedTemplate>
          <Provider store={store}>
            <QueryClientProvider client={queryClient}>
              <App />
            </QueryClientProvider>
          </Provider>
        </AuthenticatedTemplate>
      </ThemeProvider>
    </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
